/* eslint-disable @next/next/no-img-element */
import { Box, Container, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { useEffect, useState } from "react";
import { ButtonSite } from "@/components/button";
import { CardTestimony } from "@/components/cardTestimony";
import YouTubeShortsEmbed from "@/components/shorts";
import Faq from "@/components/Faq";
import { useRouter } from 'next/router'


export default function Home() {

  const router = useRouter()

    const [width, setWidth] = useState<number>(0);
    const [IsReady, setIsReady] = useState(false);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

     useEffect(() => {
        setIsReady(true)
      }, [])

    useEffect(() => {
        if (IsReady) {
            setWidth(window.innerWidth);
            window.addEventListener('resize', handleWindowSizeChange);
            return () => {
                window.removeEventListener('resize', handleWindowSizeChange);
            }
        }
    }, [IsReady]);

    const isMobile = width <= 768;

  const handleClick = () => {
    router.push("/form")
  }

  if (!IsReady) {
    return null; // ou um componente de loading
  }



  return (
    <>
      <Box
        height={1150}  
        width={'100%'}
        flex={1}
        position={'absolute'}
        top={0}
        left={0}
        right={0}
        sx={{
          backgroundImage: 'url("/images/background.png")',
          backgroundRepeat: 'no-repeat',
          // backgroundSize: 'cover',
          backgroundSize: isMobile ? "auto 675px" : '100% auto',
          backgroundPosition: isMobile ? 'left top' : 'center top'        
        }}
      />
      
      
      <Container>
        <Box
          position={'relative'}
          zIndex={99}            
        >
          <Grid 
            container
          >
            <Grid 
              size={12} 
              marginTop={isMobile ? 4 : 18}
              marginBottom={4}
            >
              <img              
                src={"/images/logoCanadaSemFronteiras.png"} 
                alt="Logo"
                width={240}
              />
            </Grid>
            <Grid 
              size={12}
              marginBottom={4}
            >
              <Typography
                fontWeight={600}
                fontSize={48}
                fontFamily={"Poppins"}
                paddingRight={2}
              >
                Seu futuro no Canadá começa aqui
              </Typography>       
            </Grid>     

            <Grid 
              size={{md:9, xs: 12}}
            >
              <Typography
                fontWeight={400}
                fontSize={18}
                fontFamily={"Poppins"}
              >
                Se você quer ter clareza sobre como trazer sua carreira para o Canadá, em apenas 9 meses, seu primeiro passo é preencher o questionário de avaliação de perfil.
              </Typography>       
            </Grid>

            <Grid 
              size={{
                xs: 12,
                md: 5
              }}
              marginTop={isMobile ? 8 : 6}
            >              
              <ButtonSite
                label="Receber minha análise de perfil"
                onClick={handleClick}
              />
            </Grid>


            <Grid 
              container
              marginTop={isMobile ? 8 : 32}
              spacing={2}
            >

              <Grid
                size={{
                  xs: 12,
                  md: 4
                }}
              >
                <CardTestimony 
                  title="Quem escolhe a Canadá Sem Fronteiras, conquista seu sonho"
                >
                  A <span style={{color: "#F1A648"}}>Canadá Sem Fronteiras</span> superou todas as minhas expectativas! A equipe é extremamente preparada, oferece <span style={{color: "#F1A648"}}>suporte em cada etapa do processo</span> e realmente se compromete em tornar o sonho da imigração realidade. Mesmo diante de desafios, nunca fiquei sem orientação ou alternativas viáveis. O atendimento é humano, ágil e eficaz, sempre focado no que é melhor para mim e minha família. Só tenho a agradecer e recomendar a todos!
                </CardTestimony>
              </Grid>

              
              
              <Grid
                size={{
                  xs: 12,                
                  md: 4
                }}
              >
                <CardTestimony 
                  title='A gente te leva "pela mão" até o Canadá'
                >
                  A equipe do <span style={{color: "#F1A648"}}>Canadá Sem Fronteiras</span> foi essencial para o início do nosso projeto! <span style={{color: "#F1A648"}}>Profissionais dedicados, que cuidam de cada etapa com carinho e atenção, desde o primeiro contato até a nossa chegada ao Canadá</span>. Hoje completamos 30 dias aqui e eles continuam nos apoiando na nossa jornada. Somos imensamente gratos e recomendamos a todos!
                </CardTestimony>
              </Grid>

              
              <Grid
                size={{
                  xs: 12,
                  md: 4
                }}
              >
                <CardTestimony 
                  title="Acreditamos no seu sonho e criamos um plano personalizado para você"
                >
                  O <span style={{color: "#F1A648"}}>Canadá Sem Fronteiras</span> foi <span style={{color: "#F1A648"}}>muito mais que uma consultoria</span> para mim. Eles acreditaram no meu sonho e <span style={{color: "#F1A648"}}>estiveram ao meu lado em cada etapa dessa jornada</span>. Nos momentos de dúvida e insegurança, a equipe sempre esteve presente para me apoiar e me lembrar que tudo daria certo — e deu! Confiar em alguém para cuidar do seu futuro não é fácil, mas com <span style={{color: "#F1A648"}}>profissionais experientes e comprometidos</span>, tudo se encaixa naturalmente. Sou imensamente grata!
                </CardTestimony>
              </Grid>
            </Grid>

           
            <Grid 
              marginTop={isMobile ? 8 : 6}
              
              size={12}
            >  

              <Box 
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >    
                <ButtonSite
                  label="Receber minha análise de perfil"
                  onClick={handleClick}
                />

              </Box>

            </Grid>


            {/* Shorts Youtube */}
            <Grid 
              container 
              marginTop={isMobile ? 8 : 6}
              display={"flex"}
              width={"100%"}
              justifyContent={"center"}
              alignItems={"center"}
              spacing={6} 
            >
              <Grid size={{xs: 12, md: 4}} display="flex" justifyContent="center">
                <YouTubeShortsEmbed url="https://www.youtube.com/embed/eHnqy4L7I5A" />
              </Grid>
              <Grid size={{xs: 12, md: 4}} display="flex" justifyContent="center">
                <YouTubeShortsEmbed url="https://www.youtube.com/embed/u7hdeS_1BQg" />
              </Grid>
              <Grid size={{xs: 12, md: 4}} display="flex" justifyContent="center">
                <YouTubeShortsEmbed url="https://www.youtube.com/embed/jPfp86UbW_8" />
              </Grid>
            </Grid> 


            <Grid 
              marginTop={20}              
            >            
              <Typography
                fontWeight={600}
                fontSize={24}
                fontFamily={"Poppins"}
              >
                Perguntas frequentes
              </Typography>               
            </Grid> 
            
            <Grid 
              size={12}
              marginTop={4}              
            >      
              <Faq 
                titulo="Como funciona a consultoria da Canadá Sem Fronteiras?"
                IsOpen
              >
                Nós analisamos seu perfil detalhadamente e criamos um plano estratégico personalizado para sua imigração. Nossa equipe acompanha todas as etapas do processo, garantindo que você tome as melhores decisões para estudar e trabalhar legalmente no Canadá.
              </Faq>
              <Faq 
                titulo="Quem pode se candidatar aos nossos serviços?"
              >
                Nosso foco são profissionais com carreira consolidada no Brasil, bom nível acadêmico e inglês intermediário ou avançado. Se você deseja estudar e trabalhar no Canadá de forma legal e estruturada, podemos te ajudar!
              </Faq>
              <Faq 
                titulo="Preciso ter inglês fluente para imigrar?"
              >
                Não necessariamente, mas um nível intermediário ou avançado aumenta suas chances de sucesso. Se necessário, podemos te orientar sobre cursos para melhorar seu inglês antes da mudança.
              </Faq>
              <Faq 
                titulo="Quanto tempo leva todo o processo?"
              >
                O tempo varia de acordo com o perfil e o programa escolhido, mas, em média, nossos clientes conseguem iniciar sua nova vida no Canadá em aproximadamente 9 meses.
              </Faq>
              <Faq 
                titulo="O Canadá Sem Fronteiras garante a aprovação do visto?"
              >
                Não podemos garantir a aprovação, pois a decisão final é da imigração canadense. No entanto, elaboramos estratégias para fortalecer seu perfil e aumentar suas chances de sucesso.
              </Faq>
              <Faq 
                titulo="Quais são as principais etapas do processo?"
              >
                1. Avaliação do seu perfil.<br/>
                2. Planejamento estratégico para sua imigração.<br/>
                3. Apoio na escolha do curso e instituição de ensino.<br/>
                4. Auxílio com documentação e visto.<br/>
                5. Orientação para adaptação no Canadá
              </Faq>
              <Faq 
                titulo="Preciso comprovar renda para estudar e trabalhar no Canadá?"
              >
                Sim. O governo canadense exige que estudantes internacionais comprovem que possuem recursos financeiros suficientes para se manter durante os estudos. A quantia exata depende da cidade e do programa escolhido.
              </Faq>
              <Faq 
                titulo="Como funciona o trabalho para estudantes no Canadá?"
              >
                Estudantes internacionais podem trabalhar até 24 horas por semana durante o período de aulas (trabalho de meio-período) e podem trabalhar em período integral (por volta de 40 horas por semana) nas férias. Além disso, após a conclusão do curso, há opções para obtenção de um visto de trabalho.
              </Faq>
              <Faq 
                titulo="A consultoria da Canadá Sem Fronteiras oferece suporte após a chegada no Canadá?"
              >
                Sim! Continuamos te acompanhando mesmo após a sua chegada, oferecendo suporte para adaptação e auxiliando em tarefas que possibilitam o início da sua nova vida no Canadá, como obtenção de documentação para trabalhar, abertura de conta bancária e, se você vier com filhos, realizamos a matrícula das crianças na escola canadense.
              </Faq>
              <Faq 
                titulo="Como posso começar o meu processo?"
              >
                O primeiro passo é preencher nosso questionário de avaliação de perfil. A partir dele, nossa equipe analisará seu perfil e entrará em contato com as melhores estratégias para sua mudança.
              </Faq>
            </Grid>
            <Grid 
              marginTop={isMobile ? 8 : 12}
              size={12}
            > 
              <Box 
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >    
                <ButtonSite
                  label="Receber minha análise de perfil"
                  onClick={handleClick}
                />
              </Box>
            </Grid>
          </Grid> 

          <Box height={100}/>
        </Box>

      </Container> 


        <Box
          height={150}
          sx={{backgroundColor: '#323232'}}
          display={'flex'}
          alignItems={'center'}
          flexDirection={'column'}
        
        >
          <Box 
           display={'flex'}
           alignItems={'center'}
           padding={4}
           gap={2}      
          >
            <a href="https://www.linkedin.com/company/canada-sem-fronteiras/">
              <img style={{cursor:'pointer'}} src="/images/Likedin.png" alt="logo" />
            </a>

            <a href="https://www.instagram.com/canadasemfronteiras/">
              <img style={{cursor:'pointer'}} src="/images/instagram.png" alt="logo" />
            </a>

            <a href="https://www.youtube.com/c/Canad%C3%A1SemFronteiras">
              <img style={{cursor:'pointer'}} src="/images/youtube.png" alt="logo" />
            </a>

            <a href="https://www.tiktok.com/@canadasemfronteiras">
              <img style={{cursor:'pointer'}} src="/images/tik-tok.png" alt="logo" height={24} />
            </a>
          </Box>

          <Typography 
              fontWeight={600}
              fontSize={'16px'}
              height={'16px'}
            >
              2026 - Canadá Sem Fronteiras
            </Typography>       

          
        </Box>
    </>
  )
}


           